import {Field} from "react-final-form";
import {composeValidators, required, emailValidator} from "../../../common/validations";
import {
  FieldContainer,
  FormFields,
} from "../../../common/components/collections/form/forms";
import Error from "src/core/common/components/elements/Error";
import React from "react";
import PhoneInputField from "../../../common/components/elements/input/PhoneInput";
import useFormsCache from "src/core/common/hooks/useFormsCache";
import curry from "lodash/curry";
import Input from "../../../common/components/elements/input/Input";
import useFeatureToggles from "../../../common/hooks/useFeatureToggles";
import {showErrorHighlight} from "src/core/common/utils";

function ContactInfoFormSection({disabled}) {
  const [phoneValue, setPhoneValue] = useFormsCache(FormFields.PHONE);
  const [emailValue, setEmailValue] = useFormsCache(FormFields.EMAIL);
  const toggles = useFeatureToggles();

  const onChangePhone = curry((callback, value) => {
    setPhoneValue(value);
    callback(value);
  });

  const onChangeEmail = curry((callback, evt) => {
    setEmailValue(evt.target.value);
    callback(evt.target.value);
  });

  const emailOnSignUpMode = toggles.emailOnSignUpMode();
  const phoneRequired = toggles.requiredPhoneOnSignUp();

  let emailValidators = [emailValidator];

  if (toggles.requiredEmailOnSignUp()) {
    emailValidators.push(required);
  }

  function computePhoneInputProps({input}) {
    return {
      disabled: disabled,
      onChange: onChangePhone(input.onChange),
    };
  }

  return (
    <>
      {toggles.requestPhoneOnSignUp() && (
        <PhoneInputField
          name={"phoneNumber"}
          isRequired={phoneRequired}
          initialValue={phoneValue}
          computePhoneInputProps={computePhoneInputProps}
        />
      )}
      {toggles.requestEmailOnSignUp() && (
        <Field
          name="email"
          validate={composeValidators(...emailValidators)}
          initialValue={emailValue}
          render={({input, meta}) => (
            <FieldContainer>
              <Input
                {...input}
                data-cy="expressCheckoutEmailField"
                disabled={false}
                hasErrors={showErrorHighlight(meta)}
                placeholder={`Email${
                  emailOnSignUpMode === "required" || toggles.loginWithEmail() ? "*" : ""
                }`}
                onChange={onChangeEmail(input.onChange)}
              />
              {meta.touched && <Error>{meta.error}</Error>}
            </FieldContainer>
          )}
        />
      )}
    </>
  );
}

export default ContactInfoFormSection;
